// src/components/Layout/AdminLayout.tsx
import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  Dashboard,
  PeopleAlt,
  HourglassEmpty,
  Agriculture,
  WhatsApp,
  Logout,
} from "@mui/icons-material";
import logoLightVertical from "../../assets/img/logo-light-vertical.png";
import sidebarStyles from "../Sidebar/Sidebar.module.css";
import containerStyles from "./container.module.css";
import Header from "../Header/Header";

const menuItems = [
  { name: "Dashboard", path: "/superadmin/dashboard", icon: <Dashboard /> },
  { name: "Usuários", path: "/superadmin/usuarios", icon: <PeopleAlt /> },
  { name: "Pendentes", path: "/superadmin/pendentes", icon: <HourglassEmpty /> },
  { name: "Fazendas", path: "/superadmin/fazendas", icon: <Agriculture /> },
  { name: "WhatsApp", path: "/superadmin/whatsapp", icon: <WhatsApp /> },
];

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div style={{ display: "flex", width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* Sidebar */}
      <aside className={sidebarStyles.containerMenuSide}>
        <div className={sidebarStyles.logoContainer}>
          <img src={logoLightVertical} alt="Inteagro" className={sidebarStyles.logoImg} />
        </div>

        {/* Badge de identificação */}
        <div style={{
          margin: "0 8px 12px",
          background: "#ff6b2b",
          borderRadius: 8,
          padding: "4px 6px",
          textAlign: "center",
        }}>
          <span style={{ fontSize: "0.6rem", fontWeight: 700, color: "#fff", letterSpacing: 1 }}>
            ADMIN
          </span>
        </div>

        <div className={sidebarStyles.MenuSideItens}>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                isActive
                  ? `${sidebarStyles.MenuSideItem} ${sidebarStyles.selected}`
                  : sidebarStyles.MenuSideItem
              }
            >
              <div className={sidebarStyles.MenuSideHidden}>
                <div className={sidebarStyles.MenuSideItemImg}>{item.icon}</div>
                <p>{item.name}</p>
              </div>
            </NavLink>
          ))}
        </div>

        {/* Logout no rodapé */}
        <button
          onClick={handleLogout}
          style={{
            marginTop: "auto",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "16px 0",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
            color: "#9aada6",
            fontSize: "0.6rem",
            width: "100%",
          }}
        >
          <Logout style={{ fontSize: 22 }} />
          Sair
        </button>
      </aside>

      {/* Conteúdo */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", marginLeft: 72, height: "100vh", overflow: "hidden" }}>
        <Header />
        <main className={containerStyles.containerPage} style={{ paddingLeft: 0, overflowY: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
